import { useGraphqlState } from "./useGraphqlState.js";
import { getEndpoint } from "./shared.js";
import { hash } from "ohash";
import { GraphqlMiddlewareCache } from "../helpers/ClientCache.js";
import { useNuxtApp, useAppConfig } from "#imports";
export function performRequest(operation, operationName, method, options, cacheOptions) {
  const state = useGraphqlState();
  const app = useNuxtApp();
  if (!state) {
    console.error(
      `A GraphQL composable for ${operation} "${operationName}" was called before the "nuxt-graphql-middleware-provide-state" plugin could provide the state, which might lead to unexpected behaviour. Make sure that custom plugins that perform GraphQL requests are executed after "nuxt-graphql-middleware-provide-state" by setting it as a dependency via "dependsOn".`
    );
  }
  const key = `${operation}:${operationName}:${hash(options.params)}`;
  if (cacheOptions) {
    const config = useAppConfig();
    if (import.meta.client && cacheOptions.client && config.graphqlMiddleware.clientCacheEnabled) {
      if (!app.$graphqlCache) {
        app.$graphqlCache = new GraphqlMiddlewareCache(
          config.graphqlMiddleware.clientCacheMaxSize
        );
      }
      const cached = app.$graphqlCache.get(key);
      if (cached) {
        return cached;
      }
    }
  }
  const promise = $fetch(
    getEndpoint(operation, operationName),
    {
      ...state && state.fetchOptions ? state.fetchOptions : {},
      ...options,
      method
    }
  ).then((v) => {
    return {
      ...v,
      data: v.data,
      errors: v.errors || []
    };
  });
  if (import.meta.client && cacheOptions?.client && app.$graphqlCache) {
    app.$graphqlCache.set(key, promise);
  }
  return promise;
}
